import { Button, Typography } from "@cur8/maneki";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { Component, type ErrorInfo, type PropsWithChildren } from "react";
import styles from "./styles.module.sass";

export class RootErrorBoundary extends Component<
  PropsWithChildren<{ appInsights: ApplicationInsights }>,
  { error: Error | null }
> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: unknown) {
    return { error: error instanceof Error ? error : new Error(String(error)) };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    const exception = error instanceof Error ? error : new Error(String(error));
    this.props.appInsights.trackException({
      exception,
      properties: { componentStack: info.componentStack },
    });
  }

  render() {
    const { error } = this.state;

    if (error) {
      return (
        <div className={styles.container}>
          <div className={styles.content}>
            <Typography variant="display-s" color="default">
              Something went wrong
            </Typography>
            <Typography variant="body-m" color="subtle">
              {error.message}
            </Typography>
            <Button onPress={() => window.location.assign("/")} fillContainer>
              Navigate to home screen
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
